import React, { useState, useRef } from 'react';
import { Divider } from 'primereact/divider';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';

import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

import WebServicesReq from './components/WebServicesReq';
import ProgramReq from './components/ProgramReq';

import { addBilsoftAsyncThunk } from '../../../store/modules/moduleSlice';
import { setLoginSuccess, setLoginToken } from '../../../store/modules/bilsoftSlice';
import { loginBilsoft } from './utils/bilsoftRequest';

export default function BilsoftPage() {
    const { selectedModule, selectedProgram, module } = useSelector((state) => state.modules);
    const { webServiceReq, programReq } = useSelector((state) => state.bilsoft);
    const { selectedCompany } = useSelector((state) => state.userCompany);

    const [pending, setPending] = useState(false);

    const dispatch = useDispatch();
    const toast = useRef(null);

    const save = async () => {
        // First, attempt bilsoft login
        try {
            const loginResponse = await loginBilsoft(programReq.taxNumber, programReq.databaseId, programReq.period, programReq.username, programReq.password, programReq.apiUsername, programReq.apiPassword);

            if (loginResponse.data.success && loginResponse.data.data.token) {
                // Login successful, save the module settings
                dispatch(setLoginSuccess(true));
                dispatch(setLoginToken(loginResponse.data.data.token));

                toast.current.show({
                    severity: 'success',
                    summary: 'Başarılı',
                    detail: 'Bilsoft girişi başarılı',
                    life: 2000
                });

                // Prepare data for module settings
                const data = {
                    companyId: selectedCompany._id,
                    module: {
                        moduleId: module._id,
                        title: module.title,
                        program: {
                            _id: selectedProgram._id,
                            title: selectedProgram.title,
                            requirements: [
                                {
                                    taxNumber: programReq.taxNumber,
                                    databaseId: programReq.databaseId,
                                    period: programReq.period,
                                    username: programReq.username,
                                    password: programReq.password,
                                    apiUsername: programReq.apiUsername,
                                    apiPassword: programReq.apiPassword
                                }
                            ]
                        },
                        webService: {
                            requirements: webServiceReq,
                            _id: selectedModule._id,
                            title: selectedModule.title,
                            url: selectedModule.url
                        },
                        bilsoftToken: loginResponse.data.data.token,
                        bilsoftExpiration: loginResponse.data.data.expiration
                    }
                };

                setPending(true);
                dispatch(addBilsoftAsyncThunk(data));

                toast.current.show({
                    severity: 'success',
                    summary: 'Başarılı',
                    detail: 'Modül Eklendi',
                    life: 1500
                });

                setTimeout(() => {
                    setPending(false);
                    window.location.reload();
                }, 1500);
            } else {
                toast.current.show({
                    severity: 'error',
                    summary: 'Hata',
                    detail: 'Bilsoft girişi başarısız - Lütfen bilgilerinizi kontrol edin',
                    life: 3000
                });
            }
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Hata',
                detail: error?.response?.data?.message || 'Bir hata oluştu',
                life: 3000
            });
        }
    };

    const programReqState = () => {
        return programReq?.taxNumber && programReq?.databaseId && programReq?.period && programReq?.username && programReq?.password && programReq?.apiUsername && programReq?.apiPassword;
    };

    const webServiceReqState = () => {
        return webServiceReq && Object.keys(webServiceReq).every((key) => webServiceReq[key]);
    };

    const isDisabled = () => {
        if (programReqState() && webServiceReqState()) {
            return false;
        }
        return true;
    };

    return (
        <>
            <Toast ref={toast} />
            <div className="flex align-items-center">
                <Button className="" icon="pi pi-building" />
                <h3 className="mb-4 ml-3">{selectedCompany?.name}</h3>
            </div>
            <div className="card">
                <div className="">
                    <div className="flex flex-column md:flex-row">
                        <div className="w-full">
                            <ProgramReq />
                        </div>

                        <div className="w-full md:w-1">
                            <Divider layout="vertical" className="hidden md:flex"></Divider>
                        </div>

                        <WebServicesReq />
                    </div>
                </div>

                <div className="text-center mt-5">
                    <Button label="Kaydet" icon="pi pi-check" className="p-button-success text-white p-mr-2 px-6" onClick={() => save()} disabled={isDisabled()} loading={pending} />
                </div>
            </div>
        </>
    );
}
